import $ from "jquery";

const lazyLoadedClassList = [
    'youtube-iframe',
    'apple-iframe',
    'yandex-iframe',
    'vimeo-iframe',
    'image-with-srcset',
];

export const lazyLoad = () => {
    lazyLoadedClassList.forEach(lazyLoadedClass => {
        addObserver(lazyLoadedClass);
    });
};

const addObserver = (className) => {
    const iframeList = $(`.${className}`);

    if (!iframeList.length) {
        return;
    }

    const observer = new IntersectionObserver(onIntersectionObserve);

    iframeList.get().forEach(iframe => {
        observer.observe(iframe);
    });
};

const onIntersectionObserve = (entries, observer) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        }

        const replacedAttribute = $(entry.target).attr('srcset') !== undefined ? 'srcset' : 'src';

        $(entry.target).attr(replacedAttribute, $(entry.target).data(replacedAttribute));

        observer.unobserve(entry.target);
    });
};
